import { TourPracticalInformationLine } from 'Components/lines/tour-practical-information-line/TourPracticalInformationLine';
export default TourPracticalInformationLine;
